import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_SELL_UNIT } from "../../../config/api";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";

export const sellUnits = createAsyncThunk(
  "realEstate/sellUnits",
  async ({ data, failed, cb }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_SELL_UNIT,
        data: data,
      });

      cb(response?.data);

      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      failed();

      return rejectWithValue(
        error.response?.data || "An unexpected error occurred"
      );
    }
  }
);
